import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Parts} from "components";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Help Desks',
	url: '/helpdesks',
	icon: 'comments'
}];

class FinancialEdits extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history, roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Financial Edits",
				url: `/helpdesks/financialedits`,
				icon: 'laptop',
			}
		]);

		return (
			<div className={'container-fluid'}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Parts.Tickers.HelpdeskTicker/>

				<Collections.Financial_Edits
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					roles={roles}
					onSessionCheck={() => this.props.rootState?.triggerAction?.('handleSessionCheck')}
				/>
			</div>

		)
	}
}

export default Framework.Components.withRootState(FinancialEdits);